<template>
  <BaseCard>
    <v-card>
      <validation-observer v-slot="{}">
        <v-card-actions class="justify-end">
          <v-col cols="2">
            <validation-provider
              :rules="{
                required: true,
                min_value: 1,
                max_value: liberados.length,
              }"
              name="quantidade"
              v-slot="{ errors }"
            >
              <v-text-field
                v-if="canUpdate"
                v-model="quantidade"
                label="Quantidade"
                type="number"
                :min="1"
                :max="liberados.length"
                :error-messages="errors"
                @input="selecionarQuantidadeAutomaticamente"
              />
            </validation-provider>
          </v-col>
          <v-col cols="2">
            <v-btn
              v-if="canAprovar"
              block
              color="primary"
              @click="aprovar"
              :disabled="quantidadeSelecionada <= 0"
              ><v-icon>mdi-thumb-up</v-icon> ({{
                quantidadeSelecionada
              }})</v-btn
            >
          </v-col>
          <v-col cols="2" class="text-center">
            <v-btn
              v-if="canRecusar"
              block
              color="error"
              @click="reprovar"
              :disabled="quantidadeSelecionada <= 0"
              ><v-icon>mdi-thumb-down</v-icon> ({{
                quantidadeSelecionada
              }})</v-btn
            >
          </v-col>
        </v-card-actions>
      </validation-observer>
    </v-card>
    <v-data-table :headers="headers" :items="liberados" class="elevation-1">
      <template v-slot:[`header.acoes`]>
        <v-icon v-if="canUpdate" @click="selecionarTodos" class="white--text">
          {{ icon }}
        </v-icon>
      </template>
      <template v-slot:[`item.acoes`]="{ item }">
        <v-checkbox :value="item.public_id" v-model="selecionados" />
      </template>
      <template v-slot:[`item.triado_em`]="{ item }">
        <span>{{ item.triado_em | toBrazilianDateTime }} </span>
      </template>
      <template v-slot:[`item.created_by`]="{ item }">
        <span>{{ item.created_by.name }} ({{ item.created_by.empresa }})</span>
      </template>
      <template v-slot:[`item.finished_at`]="{ item }">
        <span>{{ item.finished_at | toBrazilianDateTime }} </span>
      </template>
      <template v-slot:[`item.finished_by`]="{ item }">
        <span
          >{{ item.finished_by.name }} ({{ item.finished_by.empresa }})</span
        >
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <span>{{ item.created_at | toBrazilianDateTime }} </span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span>{{ getStatus(item.status) }} </span>
      </template>
      <template v-slot:[`item.numero_pedido`]="{ item }">
        <p v-for="(numero, index) in item.numeros_pedidos" :key="index">
          {{ numero }}
        </p>
      </template>
      <template v-slot:[`item.senhas`]="{ item }">
        {{ item.senhas.length ? item.senhas[0] : '-' }}
      </template>
      <template #no-data v-if="!canList">
        <span class="red--text"
          >Você não tem permissão para visualizar as informações desta
          tela</span
        >
      </template>
    </v-data-table>
  </BaseCard>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import { toBrazilianDateTime } from '@/mixins/convertion.js'
import { SolicitacaoBaixaStatus } from '@/utils/solicitacaoBaixa.js'

import {
  BasicPermissions,
  Sequences,
  CustomPermissions,
} from '@/utils/permissions'

export default {
  name: 'Solicitados',
  filters: { toBrazilianDateTime },
  data() {
    return {
      headers: [
        {
          text: 'Confirmar Trânsito',
          divider: true,
          sortable: false,
          value: 'acoes',
          class: 'primary white--text',
        },
        {
          text: 'Senha',
          divider: true,
          value: 'senhas',
          class: 'primary white--text',
        },
        {
          text: 'Fornecedor',
          divider: true,
          value: 'fornecedor.business_name',
          class: 'primary white--text',
        },
        {
          text: 'Placa Cavalo',
          divider: true,
          value: 'placa',
          class: 'primary white--text',
        },
        {
          text: 'Motorista',
          divider: true,
          value: 'motorista',
          class: 'primary white--text',
        },
        {
          text: 'Sub Produto',
          divider: true,
          value: 'sub_produtos',
          class: 'primary white--text',
        },
        {
          text: 'Embalagem',
          divider: true,
          value: 'embalagens',
          class: 'primary white--text',
        },
        {
          text: 'Triado Em',
          divider: true,
          value: 'triado_em',
          class: 'primary white--text',
        },
        {
          text: 'Número do Pedido',
          divider: true,
          value: 'numero_pedido',
          class: 'primary white--text',
        },
        {
          text: 'Terminal Destino',
          divider: true,
          value: 'terminal_destino.contratado.business_name',
          class: 'primary white--text',
        },
        {
          text: 'Transportadora',
          divider: true,
          value: 'transportadora.business_name',
          class: 'primary white--text',
        },
        {
          text: 'Destinatario',
          divider: true,
          value: 'destinatario.business_name',
          class: 'primary white--text',
        },
        {
          text: 'Modalidade',
          divider: true,
          value: 'modalidade',
          class: 'primary white--text',
        },
        {
          text: 'Solicitante',
          divider: true,
          value: 'created_by',
          class: 'primary white--text',
        },
        {
          text: 'Data/Hora',
          divider: true,
          value: 'created_at',
          class: 'primary white--text',
        },
        {
          text: 'Aprovado por',
          divider: true,
          value: 'finished_by',
          class: 'primary white--text',
        },
        {
          text: 'Data/Hora',
          divider: true,
          value: 'finished_at',
          class: 'primary white--text',
        },
        {
          text: 'Status',
          divider: true,
          value: 'status',
          class: 'primary white--text',
        },
      ],
      selecionados: [],
      interval: null,
      intervaloEmSegundos: 60,
      quantidade: null,
    }
  },

  computed: {
    ...mapState('auth', ['empresaAtual']),
    ...mapState('solicitacaoBaixa', ['liberados']),

    permission() {
      return Sequences.SolicitacaoBaixa.toString()
    },

    canList() {
      return this.$canDo(BasicPermissions.VISUALIZAR, this.permission)
    },
    canCreate() {
      return this.$canDo(BasicPermissions.CADASTRAR, this.permission)
    },
    canUpdate() {
      return this.$canDo(BasicPermissions.EDITAR, this.permission)
    },
    canAprovar() {
      return this.$canDo(CustomPermissions.APROVAR_LIBERADOS, this.permission)
    },
    canRecusar() {
      return this.$canDo(CustomPermissions.RECUSAR_LIBERADOS, this.permission)
    },
    canDelete() {
      return this.$canDo(BasicPermissions.EXCLUIR, this.permission)
    },

    quantidadeSelecionada() {
      return this.selecionados.length
    },

    selecionouTodos() {
      return this.selecionados.length === this.liberados.length
    },

    selecionouAlgum() {
      return this.selecionados.length > 0 && !this.selecionadoTodos
    },

    icon() {
      if (this.selecionouTodos) return 'mdi-close-box'
      if (this.selecionouAlgum) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },

  methods: {
    ...mapActions('solicitacaoBaixa', ['getLiberados', 'liberarCaminhoes']),
    ...mapActions('template', ['successMessage', 'errorMessage']),

    cleanSelecionados() {
      this.selecionados.splice(0)
    },

    async aprovar() {
      await this.finalizar({
        proprietario: this.empresaAtual.public_id,
        liberados: this.selecionados,
        aprovar: true,
      })
    },

    async reprovar() {
      await this.finalizar({
        proprietario: this.empresaAtual.public_id,
        liberados: this.selecionados,
        aprovar: false,
      })
    },

    async finalizar(data) {
      try {
        await this.liberarCaminhoes(data)
        this.quantidade = null
        this.selecionados = []
        this.$nextTick(() =>
          this.successMessage('Operação realizada com sucesso!')
        )
        this.$emit('atualizaResumo')
      } catch (e) {
        this.errorMessage(e.response.data)
      }
    },

    selecionarQuantidadeAutomaticamente(n) {
      this.selecionados = this.liberados.slice(0, n).map((o) => o.public_id)
    },

    selecionarTodos() {
      if (this.quantidadeSelecionada === 0) {
        this.selecionados = this.liberados.map((o) => o.public_id)
      } else {
        this.cleanSelecionados()
      }
    },

    async getItems() {
      try {
        this.cleanSelecionados()
        this.quantidade = null
        await this.getLiberados({
          proprietario: this.empresaAtual.public_id,
        })
      } catch (e) {
        this.errorMessage(e.response.data)
      }
    },

    getStatus(statusID) {
      return Object.values(SolicitacaoBaixaStatus).find(
        (o) => o.id === statusID
      ).name
    },
  },
  watch: {
    'liberados.length': {
      handler() {
        this.$emit('update:totalLiberados', String(this.liberados.length))
      },
    },
  },
  async mounted() {
    if (this.canList) {
      await this.getItems()
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
}
</script>
